function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m67.592 18.377c-0.10202 0.09231-0.20405 0.18948-0.30608 0.2915l-24.899 25.269c-2.813 2.8519-2.7936 7.4188-0.0048 10.246l3.3572 3.4106c2.7984 2.8373 7.3119 2.8276 10.101-0.0048l24.904-25.269c0.10202-0.10202 0.19434-0.20405 0.28665-0.30608l7.6423 7.7492c2.7839 2.8276 5.0528 1.8754 5.0528-2.1328v-28.942c0-1.3409-1.064-2.4146-2.3806-2.4146h-28.519c-3.9839 0-4.8973 2.298-2.1086 5.1305zm-46.728-12.102c-8.0893 0-14.59 6.5297-14.59 14.59v58.272c0 8.0893 6.5297 14.59 14.59 14.59h58.272c8.0893 0 14.59-6.5297 14.59-14.59v-37.633 20.643l-14.575-12.088v21.824c0 4.0131-3.26 7.2682-7.2682 7.2682h-43.765c-4.0131 0-7.2682-3.26-7.2682-7.2682v-43.765c0-4.0131 3.26-7.2682 7.2682-7.2682h21.882l-12.146-14.575h20.643z",
  strokeWidth: 4.8584
});

function SvgNounExternalLink704636(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounExternalLink704636);
export default __webpack_public_path__ + "static/media/noun_External Link_704636.fe437934.svg";
export { ForwardRef as ReactComponent };